export default __webpack_public_path__ + "static/media/hhs-qld-south-west.76e36864.svg";